export default "__VITE_ASSET__BYSrCL5r__"